import { createStore } from "vuex";
import auth from "./modules/auth";
import helpers from "./modules/helpers";
import modals from "./modules/modals";
import device from "./modules/device";

const store = createStore({
  modules: {
    auth,
    helpers,
    modals,
    device
  },
});

export default store;